import React from 'react';
import {
    Briefcase,
    TrendingUp,
    Cpu,
    Link
} from 'lucide-react';
import { motion } from 'framer-motion';
import './WhyKodebuild.css';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.12 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

const differentiators = [
    {
        icon: <Briefcase size={28} />,
        title: "Business-First Thinking",
        desc: "We don't build technology for technology's sake. We focus on solutions that solve real business problems."
    },
    {
        icon: <TrendingUp size={28} />,
        title: "Built to Scale",
        desc: "We design systems with the future in mind, so your technology can grow alongside your organization."
    },
    {
        icon: <Cpu size={28} />,
        title: "Modern Engineering",
        desc: "We use modern technologies and engineering practices to create reliable, maintainable solutions."
    },
    {
        icon: <Link size={28} />,
        title: "One Technology Partner",
        desc: "From websites and mobile apps to cloud infrastructure and automation, we help bring your digital ecosystem together."
    }
];

const WhyKodebuild = () => {
    return (
        <section id="why-kodebuild" className="why-section-light">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="section-badge">Differentiators</span>
                    <h2 className="section-title text-dark">Why Build With KodeBuild?</h2>
                    <p className="section-description">
                        We bring a unique blend of engineering excellence and strategic business alignment.
                    </p>
                </motion.div>

                <motion.div
                    className="why-grid-new"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                >
                    {differentiators.map((item, i) => (
                        <motion.div key={i} variants={itemVariants} className="why-card-new">
                            <div className="why-icon-new">{item.icon}</div>
                            <div className="why-content-new">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default WhyKodebuild;
